module.exports = __webpack_public_path__ + "img/4@2x.b95d54d7.png";